module.exports = " <div class=reservation-filter> <div class=form-group> <checkbox-group :values.sync=displayStatuses> <checkbox-button :value=5>キャンセル</checkbox-button> <checkbox-button :value=6>来店なし</checkbox-button> <checkbox-button :value=-1>削除済み</checkbox-button> </checkbox-group> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/reservation-filter.vue
// module id = 227
// module chunks = 0